angular.module('iqxCore')
  .controller('CandidateDocumentsCtrl', function ($scope, $q, $timeout, $http, $routeParams, FormSvc, ApplicationSvc, ApiSvc, QuestionnaireSvc, Upload) {
    $scope.PersonID = $routeParams.id
    if ($scope.isSwitchedOn('WIZARDALLOWPDFCV')) {
      $scope.CVuploadTypes = [
        {
          "value": "primary_cv",
          "descrip": "Document (.pdf, .doc, .docx)",
          "accept": ".pdf,.doc,.docx"
        }
      ]
    } else {
      $scope.CVuploadTypes = [
        {
          "value": "primary_cv",
          "descrip": "Document (.doc, .docx)",
          "accept": ".doc,.docx"
        }
      ]
    }

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidatedocuments' + ($scope.PersonID ? '?pPersonID=' + $scope.PersonID : ''),
      multiRow: true,
      doNotPreventNav: true,
      saveWithPersonID: ($scope.PersonID ? false : true),
      fetchWithPersonID: ($scope.PersonID ? false : true),
      dateFields: ['LastUpdate']
    })

    $scope.theRecord = {}

    $scope.changedType = function () {
      angular.forEach($scope.uploadTypes, function (ut) {
        if (ut.Value === $scope.theRecord.Type) {
          $scope.theRecord.Description = ut.Description
        }
      })
      $scope.tags = []
      if (!$scope.userHasRight('DOCQUESTIONNAIRE')) {
        return $q.when('No questionnaire')  // Return a promise in case chaining required
      }
      return QuestionnaireSvc.fetch($scope, {  // Fetch linked questions (compliance docs functionality)
        tagTarget: 'tags',
        tagLocation: 'P',
        documentType: $scope.theRecord.Type,
        id: $scope.xPerson.PersonID
      })
        .then(function () {
          if ($scope.tags && $scope.tags.length) {
            QuestionnaireSvc.reset($scope, { tagTarget: 'tags' })  // Ensure in pristine state
            $timeout(function () {  // Must be done after fully loaded
              QuestionnaireSvc.linkFormFields($scope, { tagTarget: 'tags' })
              $scope.$broadcast('isEditing', true)
            }, 0, true, true)
          }
        })
        .catch(function (e) {

        })
    }

    $scope.showDocument = function (doc) {
      if ($scope.isApp !== true && $scope.isWebView !== true) {
        var _newTab = window.open('about:blank', '_blank')
      }
      doc.downloadError = ''
      $http.get('/api/document/doxi', { params: { id: doc.DocumentID, personid: doc.PersonID, type: doc.SpecialType } })
        .then(function (res) {
          setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
            var downloadURL = '/api/document/download?doxi=' + res.data + '&filename=' + encodeURIComponent(doc.DocDescription + '.' + doc.FileExtension)
            if ($scope.isApp !== true && $scope.isWebView !== true) {
              _newTab.location.href = downloadURL
            } else {
              window.open(downloadURL, '_blank')
            }
          }, 100)
        })
        .catch(function (err) {
          doc.downloadError = ApiSvc.ExtractError(err)
        })
    }

    $scope.uploadSelect = function (files, file, event) {
      $scope.theForm.file.$touched = true  // Show any validation error on the selected file
    }

    $scope.uploadCleanup = function () {
      $scope.reset()
      $scope.uploadProgress = ''
      $scope.uploadError = ''
      $scope.theRecord = {}
      $scope.tags = []
    }

    $scope.uploadFileName = function () {
      if ($scope.theRecord.file) {
        return $scope.theRecord.file.name
      } else {
        return 'Select file..'
      }
    }

    $scope.showUploadProgress = function (evt) {
      var s = 'Uploading...'
      if (evt && evt.total) {  // progress callback
        s = s + parseInt(100.0 * evt.loaded / evt.total) + '%'
      }
      $scope.uploadProgress = s
    }

    $scope.uploadExecute = function () {
      $scope.setSubmitted(true) // Ensure all validation errors appear
      if ($scope.uploadProgress || $scope.theForm.$invalid) { return }
      $scope.uploadError = ''
      $scope.showUploadProgress()
      Upload.upload({
        url: '/api/document/upload',
        file: $scope.theRecord.file,
        fileFormDataName: 'file',
        headers: { 'X-Auth': ApplicationSvc.currentUser.token },
        fields: {
          'Type': $scope.theRecord.Type,
          'Description': $scope.theRecord.Description,
          'PersonID': $scope.xPerson.PersonID
        }
      })
        .then(function (res) {
          ApiSvc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, throws exception with the message
          $scope.uploadProgress = 'Upload complete'
          return $timeout(function () { }, 2000)  // Display the Upload complete message for 2 seconds before refreshing and cleaning up
        }, null, $scope.showUploadProgress) // 3rd arg is the progress callback
        .then(function () {
          if ($scope.tags && $scope.tags.length) {  // Save the questionnaire
            $scope.qanswers = QuestionnaireSvc.answers($scope, { tagTarget: 'tags' })
            return $scope.exec('call/NetQuestSet', { qanswers: $scope.qanswers, pID: $scope.xPerson.PersonID, pLocation: 'P' })
          }
        })
        .then(function () {
          if ($scope.isSwitchedOn('POPUPDOCUPDISABLE')) {
            return true
          }
          return $scope.exec('call/NetMessage', {
            ptype: 'DOCUMENTUPLOAD',
            ptitle: $scope.userName() + ' ' + $scope.theRecord.Description + ' Uploaded',
            pdescription: ''
          })
        })
        .then(function () {
          FormSvc.alert("File Uploaded", "Your file has been uploaded\n\nA consultant may need to review the file before it is available on the web.", "success")
          return $scope.fetch()  // Refresh the list
        })
        .then(function () {
          $scope.uploadCleanup()
        })
        .catch(function (err) {
          $scope.uploadProgress = ''
          FormSvc.alert("Upload Failed", err.iqxError.text, "error")
          return $q.reject($scope.uploadError = ApiSvc.ExtractError(err))
        })
    }

    $scope.fetch()
      .then(function () {
        return $scope.fetch({
          fetchAPI: 'callresult/netuploadtypes?pOwnerType=P',
          fetchTarget: 'uploadTypes',
          multiRow: true
        })
      })
      .then(function () {
        if ($scope.PersonID) {   // Sec Agency - we need the candidate name
          return $scope.fetch({ fetchAPI: 'callresult/netcandidateprofile?pPersonID=' + $scope.PersonID, fetchTarget: 'xPerson' })
        } else { // If any documents were downloaded take the first PersonID from them
          $scope.xPerson = { PersonID: ($scope.PersonID ? $scope.PersonID : ApplicationSvc.currentUser.personID) }
        }
      })
      .then(function () {
        if ($scope.xPerson.Forenames) {
          $scope.xPerson.Fullname = FormSvc.getFirstWord($scope.xPerson.Forenames) + ' ' + $scope.xPerson.Surname
        }
      })
  })
